
export const loadChapterContent = async (tutorialId: string, chapterSlug: string): Promise<string> => {
  try {
    const response = await fetch(`/content/tutorials/${tutorialId}/${chapterSlug}.md`);
    if (!response.ok) {
      throw new Error(`Failed to load chapter: ${response.statusText}`);
    }
    return await response.text();
  } catch (error) {
    console.error('Error loading chapter content:', error);
    return '# Error loading content\n\nUnable to load the requested chapter content.';
  }
};

export const loadTutorialMetadata = async (tutorialId: string): Promise<any> => {
  try {
    const response = await fetch(`/content/tutorials/${tutorialId}/metadata.json`);
    if (!response.ok) {
      throw new Error(`Failed to load tutorial metadata: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading tutorial metadata:', error);
    return null;
  }
};

export const loadAllTutorialMetadata = async (): Promise<any[]> => {
  try {
    const response = await fetch('/content/tutorials/index.json');
    if (!response.ok) {
      throw new Error(`Failed to load tutorials index: ${response.statusText}`);
    }
    
    const index = await response.json();
    const tutorialIds = index.tutorialIds;
    
    const metadataPromises = tutorialIds.map(id => loadTutorialMetadata(id));
    return await Promise.all(metadataPromises);
  } catch (error) {
    console.error('Error loading all tutorial metadata:', error);
    // Fall back to static data if needed
    const { tutorials } = await import('./sample-data');
    return tutorials;
  }
};

export const loadCategories = async (): Promise<any> => {
  try {
    const response = await fetch('/content/categories.json');
    if (!response.ok) {
      throw new Error(`Failed to load categories: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading categories:', error);
    return null;
  }
};

export const getTutorialsByCategory = async (categoryId: string): Promise<any[]> => {
  try {
    const categoriesData = await loadCategories();
    const category = categoriesData.categories.find((c: any) => c.id === categoryId);
    
    if (!category) {
      return [];
    }
    
    const tutorialIds = category.tutorialIds;
    const metadataPromises = tutorialIds.map((id: string) => loadTutorialMetadata(id));
    return await Promise.all(metadataPromises);
  } catch (error) {
    console.error('Error loading tutorials by category:', error);
    return [];
  }
};
